<div class="ce-row">
  <div class="ce-col-lg-4 ce-col-md-12 ce-col-sm-12 ce-col-12 trend-widget-container">
    <app-global-loader-wrapper [resource]="paymentAnalyticsResource">
      <ng-template>
        <app-analytics-trend-widget
          title="Total payments value"
          metricsKey="total_payments_value"
          formatter="currency"
          [context]="rangeContext()"
          [analytics]="paymentAnalyticsResource.value()">
        </app-analytics-trend-widget>
      </ng-template>
    </app-global-loader-wrapper>
  </div>

  <div class="ce-col-lg-4 ce-col-md-12 ce-col-sm-12 ce-col-12 trend-widget-container">
    <app-global-loader-wrapper [resource]="paymentAnalyticsResource">
      <ng-template>
        <app-analytics-trend-widget
          title="Total payments"
          metricsKey="total_payments"
          [context]="rangeContext()"
          [analytics]="paymentAnalyticsResource.value()">
        </app-analytics-trend-widget>
      </ng-template>
    </app-global-loader-wrapper>
  </div>
  <div class="ce-col-lg-4 ce-col-md-12 ce-col-sm-12 ce-col-12 trend-widget-container">
    <app-global-loader-wrapper [resource]="paymentAnalyticsResource">
      <ng-template>
        <app-analytics-trend-widget
          title="Total refunds"
          metricsKey="total_refunds"
          [context]="rangeContext()"
          [analytics]="paymentAnalyticsResource.value()">
        </app-analytics-trend-widget>
      </ng-template>
    </app-global-loader-wrapper>
  </div>
</div>

<!-- Added Payment Method Distribution Chart -->
<div class="ce-row">
  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12">
    <div class="grid analytics-grid">
      <app-global-loader-wrapper
        [resource]="paymentMethodDistributionResource"
        headingTitle="Payment Methods"
        subtitle="Distribution of successful payments by method">
        <ng-template>
          <app-high-chart-container
            class="w-100"
            [chartOptions]="paymentMethodDistributionResource.value()"
            [chartType]="'pie'">
          </app-high-chart-container>
        </ng-template>
      </app-global-loader-wrapper>
    </div>
  </div>
  <!-- Add other charts for payments dashboard here in new columns -->
</div>
